export default __webpack_public_path__ + "static/media/Ranae.c42ff08c.mp3";